import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setCurrentModule, setCurrentRoute } from '../redux/reducers/utils/navReducer';

/**
 * Хук для управления навигацией и маршрутизацией
 * Отслеживает изменения пути и обновляет состояние роутера
 */
const useAppNavigation = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { currentRoute } = useSelector((store) => store.nav);

  useEffect(() => {
    // Редирект с главной страницы на дашборд кухни
    if (location.pathname === '/') {
      dispatch(setCurrentRoute('/kitchen/dashboard'));
      dispatch(setCurrentModule('kitchen'));
      navigate('/kitchen/dashboard');
      return;
    }

    // Обновление текущего маршрута, если он изменился
    if (location.pathname !== currentRoute) {
      const route = location.pathname.substring(1);
      const module = route.split('/')[0];
      
      dispatch(setCurrentRoute(route));
      dispatch(setCurrentModule(module));
    }
  }, [location.pathname, currentRoute, dispatch, navigate]);
};

export default useAppNavigation;
